"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Attribute: ()=>Attribute
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const cn_cjs_namespaceObject = require("../../utils/cn.cjs");
const index_cjs_namespaceObject = require("../CdnIcon/index.cjs");
const external_Image_index_cjs_namespaceObject = require("../Image/index.cjs");
const external_PlainA_index_cjs_namespaceObject = require("../PlainA/index.cjs");
const external_Text_index_cjs_namespaceObject = require("../Text/index.cjs");
const external_Attribute_utils_cjs_namespaceObject = require("./Attribute.utils.cjs");
const external_Attribute_variants_cjs_namespaceObject = require("./Attribute.variants.cjs");
const Attribute = ({ actionIconName, actionIconText, altText, className, href, iconName, imageUrl, isVertical, size, text, onClick, slots = {
    root: '',
    imageIconWrapperSlot: '',
    iconSlot: '',
    imageSlot: '',
    textSlot: ''
} })=>{
    const isActionable = Boolean(href) || Boolean(onClick);
    const showImage = Boolean(imageUrl && altText && !(!isVertical && iconName));
    const { imageIconWrapperSlot, iconSlot, imageSlot, root, textSlot } = (0, external_Attribute_variants_cjs_namespaceObject.attributeVariants)({
        hasIcon: Boolean(iconName),
        isActionable,
        isVertical,
        showImage,
        size
    });
    const isSmall = 'sm' === size;
    const rootClasses = (0, cn_cjs_namespaceObject.cn)(root(), className ?? slots.root);
    const imageIconWrapperSlotClasses = (0, cn_cjs_namespaceObject.cn)(imageIconWrapperSlot(), slots.imageIconWrapperSlot);
    const iconSlotClasses = (0, cn_cjs_namespaceObject.cn)(iconSlot(), slots.iconSlot);
    const imageSlotClasses = (0, cn_cjs_namespaceObject.cn)(imageSlot(), slots.imageSlot);
    const textSlotClasses = (0, cn_cjs_namespaceObject.cn)(textSlot(), slots.textSlot);
    const iconSize = (0, external_Attribute_utils_cjs_namespaceObject.getIconSize)({
        isSmall,
        isVertical,
        showImage
    });
    const horizontalImageSize = isSmall ? 4 : 5;
    const fontSize = isSmall ? 'body3' : 'body2';
    const actionType = href ? 'a' : 'button';
    const Component = isActionable ? actionType : 'div';
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(Component, {
        className: rootClasses,
        onClick: onClick,
        href: href,
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                className: imageIconWrapperSlotClasses,
                children: [
                    showImage ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Image_index_cjs_namespaceObject.Image, {
                        src: imageUrl,
                        alt: altText,
                        borderRadius: isVertical ? 'md' : 'sm',
                        width: 'auto',
                        height: isVertical ? 'full' : horizontalImageSize,
                        className: imageSlotClasses
                    }) : null,
                    iconName ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
                        iconName: iconName,
                        size: iconSize,
                        className: iconSlotClasses
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.Span, {
                        textStyle: fontSize,
                        className: textSlotClasses,
                        children: text
                    }),
                    isActionable && (actionIconName || actionIconText) ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_PlainA_index_cjs_namespaceObject.PlainA, {
                        iconLeft: actionIconName,
                        textStyle: fontSize,
                        children: actionIconText
                    }) : null
                ]
            })
        ]
    });
};
exports.Attribute = __webpack_exports__.Attribute;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Attribute"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
